import {
  OVERVIEW_ACTIVE,
  OVERVIEW_INACTIVE,
  FOLDER_ACTIVE,
  FOLDER_INACTIVE,
  NOTIFICATION_ACTIVE,
  NOTIFICATION_INACTIVE,
  SETTING_ACTIVE,
  SETTING_INACTIVE,
} from "../../../../assets";

export const BaliffSidebarRoute = [
  {
    title: "Overview",
    activeIcon: OVERVIEW_ACTIVE,
    inactiveIcon: OVERVIEW_INACTIVE,
    path: "/baliff/overview",
  },
  {
    title: "Case Folders",
    activeIcon: FOLDER_ACTIVE,
    inactiveIcon: FOLDER_INACTIVE,
    path: "/baliff/case-folders",
  },

  {
    title: "Notification",
    activeIcon: NOTIFICATION_ACTIVE,
    inactiveIcon: NOTIFICATION_INACTIVE,
    path: "/baliff/notification",
  },
  {
    title: "Setting",
    activeIcon: SETTING_ACTIVE,
    inactiveIcon: SETTING_INACTIVE,
    path: "/baliff/setting",
  },
];
